import customer from '@/backend/services/account/customer';
import { searchUser } from '@/backend/services/sso/sso';
import {
	seoCountryList,
	scanFrequencyList,
	scanSourceList,
	consumeCycleList,
} from '@/common/dictionary';

let ordersGroups = ({ obj, validRequired,validNum, serviceName, options, type, userList }) => {
	let language = obj.flagLanguageReport;
	let groups = {
		website: {
			label: '',
			data: '外贸智能云建站',
			formType: 'sky-line',
			displayWith() {
				return serviceName === 'Site';
			},
		},
		// 字段暂时隐藏
		// sitePlatform: {
		// 	label: '建站平台',
		// 	formType: 'sky-select',
		// 	'disabled-option': item => item.value == 1,
		// 	options: options.sitePlatform.slice(1),
		// 	value: obj.sitePlatform || "",
		// 	rules: [validRequired('此项必填', 'change')],
		// 	change(val) {
		// 		groups.siteType.value = '';
		// 		if (val == 2) {
		// 			groups.siteType.options = [
		// 				{
		// 					label: 'PC站',
		// 					value: 1,
		// 				},
		// 			];
		// 		} else {
		// 			groups.siteType.options = options.terminalList;
		// 		}
		// 	},
		// 	displayWith() {
		// 		return serviceName === 'Site';
		// 	},
		// },
		siteType: {
			label: '网站类型',
			formType: 'sky-select',
			options: options.terminalList,
			value: obj.siteType,
			rules: [validRequired('此项必填', 'change')],
			displayWith() {
				return serviceName === 'Site';
			},
		},
		qyEmailType: {
			label: '企业邮箱',
			formType: 'sky-select',
			options: options.companyEmail,
			value: obj.qyEmailType,
			rules: [validRequired('此项必填', 'change')],
			displayWith() {
				return serviceName === 'Site';
			},
		},
		siteFlowId: {
			label: '网建任务流',
			formType: 'sky-select',
			options: options.getTaskFlowList(1),
			props: {
				label: 'name',
				value: 'id',
			},
			value: obj.flowId,
			rules: [validRequired('此项必填', 'change')],
			displayWith() {
				return serviceName === 'Site';
			},
		},
		languageList: {
			label: '语种',
			formType: 'sky-select',
			options: options.lang,
			dict: 131,
			multiple: true,
			props: {
				label: 'name',
				value: 'code',
			},
			value: obj.languageList || [],
			rules: [validRequired('此项必填', 'change')],
			change(val) {
				obj.languageList = val;
			},
			displayWith() {
				return serviceName === 'Site';
			},
		},
		languageDefault: {
			label: '默认语种',
			formType: 'sky-select',
			options: options.lang,
			dict: 131,
			props: {
				label: 'name',
				value: 'code',
			},
			value: obj.languageDefault || '',
			rules: [validRequired('此项必填', 'change')],
			displayWith() {
				return serviceName === 'Site';
			},
		},
		industryType: {
			label: '行业',
			type: 'custom',
			formType: type.industry,
			requestApi: customer.getIndustry,
			value: [obj.primaryIndustry, obj.secondIndustry],
			rules: [
				{
					required: true,
					validator: (rule, value, callback) => {
						if (value[0] && value[1]) {
							callback();
						} else {
							callback(new Error('此项必填'));
						}
					},
					trigger: 'change',
				},
			],
			displayWith() {
				return serviceName === 'Site';
			},
		},
		domainService: {
			label: '域名服务',
			formType: 'sky-select',
			options: options.domainType,
			value: obj.domainService,
			rules: [validRequired('此项必填', 'change')],
			displayWith() {
				return serviceName === 'Site';
			},
		},
		domainTransfer: {
			label: '转移域名',
			formType: 'sky-select',
			options: options.isTransfer,
			value: obj.domainTransfer,
			rules: [validRequired('此项必填', 'change')],
			displayWith() {
				return serviceName === 'Site';
			},
		},
		spaceService: {
			label: '空间服务',
			formType: 'sky-select',
			options: options.serviceLocate,
			value: obj.spaceService,
			rules: [validRequired('此项必填', 'change')],
			displayWith() {
				return serviceName === 'Site';
			},
		},
		domain: {
			label: '网站域名',
			formType: 'sky-input',
			value: obj.domain,
			rules: [validRequired('此项必填')],
			displayWith() {
				return serviceName === 'Site';
			},
		},
		referDesign: {
			label: '设计参考',
			formType: 'sky-input',
			value: obj.referDesign,
			rules: [validRequired('此项必填')],
			displayWith() {
				return serviceName === 'Site';
			},
		},
		google: {
			label: '',
			data: 'Google广告管理',
			formType: 'sky-line',
			displayWith() {
				return serviceName === 'Google';
			},
		},
		googleFlowId: {
			label: '谷歌任务流',
			formType: 'sky-select',
			options: options.getTaskFlowList(3),
			props: {
				label: 'name',
				value: 'id',
			},
			value: obj.flowId,
			rules: [validRequired('此项必填', 'change')],
			displayWith() {
				return serviceName === 'Google';
			},
		},
		cid: {
			label: 'CID',
			formType: 'sky-input',
			value: obj.cidAccountVal,
			displayWith() {
				return serviceName === 'Google';
			},
		},
		flagLanguageReport: {
			label: '小语种报告',
			formType: 'sky-switch',
			value: obj.flagLanguageReport,
			// rules: [validRequired('此项必填', 'change')],
			displayWith() {
				return serviceName === 'Google';
			},
			change(val) {
				language = val;
			},
		},
		googleLanguageList: {
			label: '小语种',
			formType: 'sky-select',
			multiple: true,
			options: [{ label: '西班牙语', value: 131010 }],
			value: obj.languageList,
			rules: [validRequired('此项必填', 'change')],
			displayWith() {
				if (!language) this.value = [];
				return serviceName === 'Google' && language;
			},
		},
		languageServiceStaffId: {
			label: '小语种优化师',
			formType: 'sky-asyncSelect',
			value: obj.languageServiceStaffId,
			props: {
				label: 'showName',
				value: 'id',
			},
			clearable: true,
			defaultValue: obj.languageServiceStaffName,
			rules: [validRequired('此项必填', 'change')],
			displayWith() {
				if (!language) this.value = '';
				return serviceName === 'Google' && language;
			},
			setLabelFun(val) {
				groups.languageServiceStaffName.value = val
					.split('(')
					.slice(0, val.split('(').length - 1)
					.join('');
			},
			queryFunc: async query => {
				let result = await searchUser({
					name: query,
					onPosition: '0',
				});
				return result;
			},
		},
		languageServiceStaffName: {
			label: 'CID',
			formType: 'sky-input',
			value: obj.languageServiceStaffName,
			displayWith() {
				return false;
			},
		},
		socialMedia: {
			label: '',
			data: '社媒建设',
			formType: 'sky-line',
			displayWith() {
				return serviceName === 'Media';
			},
		},
		mediafaxFlowId: {
			label: '社媒任务流',
			formType: 'sky-select',
			options: options.getTaskFlowList(2),
			props: {
				label: 'name',
				value: 'id',
			},
			value: obj.flowId,
			rules: [validRequired('此项必填', 'change')],
			displayWith() {
				return serviceName === 'Media';
			},
		},
		platformList: {
			label: '平台',
			type: 'custom',
			formType: type.platform,
			options: options.mediaPlatForm,
			value: obj.platformList || [],
			rules: [validRequired('此项必填', 'change')],
			displayWith() {
				return serviceName === 'Media';
			},
		},
		socialMediaOperation: {
			label: '',
			data: 'SNS跨平台云社交',
			formType: 'sky-line',
			displayWith() {
				return serviceName === 'MediaOperation';
			},
		},
		subject: {
			label: '社媒主体',
			formType: 'sky-input',
			value: obj.subject,
			rules: [validRequired('此项必填')],
			displayWith() {
				return serviceName === 'MediaOperation';
			},
		},
    // 取消
		// mediafaxFlowId1: {
		// 	label: '社媒任务流',
		// 	formType: 'sky-select',
		// 	options: options.getTaskFlowList(6),
		// 	props: {
		// 		label: 'name',
		// 		value: 'id',
		// 	},
		// 	value: obj.operationFlowId,
		// 	rules: [validRequired('此项必填', 'change')],
		// 	displayWith() {
		// 		return serviceName === 'MediaOperation';
		// 	},
		// },
		// platformLists: {
		// 	label: '平台',
		// 	type: 'custom',
		// 	formType: type.platform,
		// 	options: options.mediaPlatForm,
		// 	value: obj.platformList || [],
		// 	rules: [validRequired('此项必填', 'change')],
		// 	displayWith() {
		// 		return serviceName === 'MediaOperation';
		// 	},
		// },
		taskCount: {
			label: '单月应发/平台',
			formType: 'sky-input',
			value: obj.taskCount,
			rules: [validRequired('此项必填')],
			displayWith() {
				return serviceName === 'MediaOperation';
			},
		},
		video: {
			label: '',
			data: '视频拍摄',
			formType: 'sky-line',
			displayWith() {
				return serviceName === 'Video';
			},
		},
		videoFlowId: {
			label: '视频拍摄任务流',
			formType: 'sky-select',
			options: options.getTaskFlowList(4),
			props: {
				label: 'name',
				value: 'id',
			},
			value: obj.flowId,
			rules: [validRequired('此项必填', 'change')],
			displayWith() {
				return serviceName === 'Video';
			},
		},
		mins: {
			label: '视频拍摄时长',
			formType: 'sky-input',
			value: obj.mins,
			rules: [validRequired('此项必填')],
			displayWith() {
				return serviceName === 'Video';
			},
		},
		number: {
			label: '视频拍摄个数',
			formType: 'sky-input',
			value: obj.number,
			rules: [validRequired('此项必填')],
			displayWith() {
				return serviceName === 'Video';
			},
		},
		flagSubtitle: {
			label: '是否有字幕',
			labelWidth: '165px',
			formType: 'sky-radio',
			value: obj.flagSubtitle,
			options: [
				{
					label: '是',
					value: true,
				},
				{
					label: '否',
					value: false,
				},
			],
			rules: [validRequired('此项必填', 'change')],
			displayWith() {
				return serviceName === 'Video';
			},
		},
		flagUploadYoutube: {
			label: '是否上传YouTube',
			labelWidth: '165px',
			formType: 'sky-radio',
			value: obj.flagUploadYoutube,
			options: [
				{
					label: '是',
					value: true,
				},
				{
					label: '否',
					value: false,
				},
			],
			rules: [validRequired('此项必填', 'change')],
			displayWith() {
				return serviceName === 'Video';
			},
		},
		FB: {
			label: '',
			data: 'Facebook广告管理',
			formType: 'sky-line',
			displayWith() {
				return serviceName === 'Facebook';
			},
		},
		FBFlowId: {
			label: 'FB任务流',
			formType: 'sky-select',
			options: options.getTaskFlowList(7),
			props: {
				label: 'name',
				value: 'id',
			},
			value: obj.flowId,
			rules: [validRequired('此项必填', 'change')],
			displayWith() {
				return serviceName === 'Facebook';
			},
		},
		FBID: {
			label: 'FBID',
			formType: 'sky-input',
			value: obj.cidAccountVal,
			rules: [validRequired('此项必填')],
			displayWith() {
				return serviceName === 'Facebook';
			},
		},
		SEO: {
			label: '',
			data: 'SEO排名监控',
			formType: 'sky-line',
			displayWith() {
				return serviceName === 'seoRank';
			},
		},
		countryIdList: {
			label: '扫描国家地区',
			formType: 'sky-select',
			multiple: true,
			options: seoCountryList,
			value: obj.countryIdList || [],
			displayWith() {
				return serviceName === 'seoRank';
			},
			rules: [validRequired('此项必填')],
		},
		scanFrequency: {
			label: '扫描频次',
			formType: 'sky-select',
			options: scanFrequencyList,
			value: obj.scanFrequency || '',
			displayWith() {
				return serviceName === 'seoRank';
			},
			rules: [validRequired('此项必填')],
		},
		scanSource: {
			label: '扫描次序',
			formType: 'sky-select',
			options: scanSourceList,
			value: obj.scanSource || '',
			displayWith() {
				return serviceName === 'seoRank';
			},
			rules: [validRequired('此项必填')],
		},
		scanPage: {
			label: '扫描页数',
			formType: 'sky-input',
			inputType: 'number',
			min: 0,
			max: 10,
			value: obj.scanPage || '',
			displayWith() {
				return serviceName === 'seoRank';
			},
			rules: [validRequired('此项必填')],
		},
		consumeCycle: {
			label: '关键词消耗时间',
			formType: 'sky-select',
			options: consumeCycleList,
			value: obj.consumeCycle || '',
			displayWith() {
				return serviceName === 'seoRank';
			},
			rules: [validRequired('此项必填')],
		},
		filterKeywordList: {
			label: '过滤关键字列表',
			formType: 'sky-input',
			placeholder: '多个请用逗号隔开',
			displayWith() {
				return serviceName === 'seoRank';
			},
			value: obj.filterKeywordList ? obj.filterKeywordList.join(',') : '',
			// rules: [validRequired('此项必填')],
		},
		WhatsApp: {
			label: '',
			data: 'WhatsApp服务',
			formType: 'sky-line',
			displayWith() {
				return serviceName === 'WhatsApp';
			},
		},
		flowId: {
			label: 'WhatsApp任务流',
			formType: 'sky-select',
			options: options.getTaskFlowList(21),
			props: {
				label: 'name',
				value: 'id',
			},
			value: obj.flowId,
			rules: [validRequired('此项必填', 'change')],
			displayWith() {
				return serviceName === 'WhatsApp';
			},
		},
		account: {
			label: 'WABA账号ID',
			formType: 'sky-input-button',
			value: obj.account || '',
			displayWith() {
				return serviceName === 'WhatsApp';
			},
			rules: [validRequired('此项必填'), validNum()],
		},
		mobile: {
			label: ' 手机号',
			formType: 'sky-input',
			value: obj.mobile || '',
			displayWith() {
				return serviceName === 'WhatsApp';
			},
			rules: [validRequired('此项必填')],
		},
		yandex: {
			label: '',
			data: 'Yandex推广',
			formType: 'sky-line',
			displayWith() {
				return serviceName === 'Yandex';
			},
		},
		yandexFlowId: {
			label: 'Yandex任务流',
			formType: 'sky-select',
			options: options.getTaskFlowList(22),
			props: {
				label: 'name',
				value: 'id',
			},
			value: obj.flowId,
			rules: [validRequired('此项必填', 'change')],
			displayWith() {
				return serviceName === 'Yandex';
			},
		},
		yandexCidAccountVal: {
			label: 'CID',
			formType: 'sky-input',
			value: obj.cidAccountVal,
			displayWith() {
				return serviceName === 'Yandex';
			},
		},
		linkedIn: {
			label: '',
			data: 'LinkedIn推广',
			formType: 'sky-line',
			displayWith() {
				return serviceName === 'LinkedIn';
			},
		},
		linkedInFlowId: {
			label: 'LinkedIn任务流',
			formType: 'sky-select',
			options: options.getTaskFlowList(23),
			props: {
				label: 'name',
				value: 'id',
			},
			value: obj.flowId,
			rules: [validRequired('此项必填', 'change')],
			displayWith() {
				return serviceName === 'LinkedIn';
			},
		},
		linkedInCidAccountVal: {
			label: 'CID',
			formType: 'sky-input',
			value: obj.cidAccountVal,
			displayWith() {
				return serviceName === 'LinkedIn';
			},
		},
	};
	return groups;
};

export default ordersGroups;
